export function formatLabel(label: string): string {
  if (!label) {
    return "";
  }
  return label.trim();
}

export function toCsv(headers: readonly string[], rows: Array<Record<string, string>>): string {
  const escapeCell = (value: string) => `"${value?.replace(/"/g, '""') ?? ""}"`;
  const headerRow = headers.join(";");
  const bodyRows = rows.map((row) =>
    headers.map((header) => escapeCell(row[header] ?? "")).join(";")
  );
  return [headerRow, ...bodyRows].join("\n");
}

export function formatRelativeCount(count: number, singular: string, plural: string): string {
  if (count === 0) {
    return `No ${plural}`;
  }
  if (count === 1) {
    return `1 ${singular}`;
  }
  return `${count} ${plural}`;
}
